import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';
import TeamSection from './components/TeamSection';
import AboutSection from './components/AboutSection';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Schema.org JSON-LD for Organization
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "株式会社ソーシャルパス",
      "url": siteUrl,
      "description": "情報の真正性検証技術の研究開発、環境固有性NFT・ロバストネスNFTの活用、情報セキュリティソリューションを提供する企業",
      "foundingDate": "2023",
      "founder": {
        "@type": "Person",
        "name": "三村 昌裕"
      },
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "JP"
      }
    };

    // Schema.org JSON-LD for WebSite
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "株式会社ソーシャルパス",
      "url": siteUrl,
      "description": "株式会社ソーシャルパスは情報の真正性検証技術の研究開発、環境固有性NFT・ロバストネスNFTの活用、情報セキュリティソリューションを提供する企業です。",
      "publisher": {
        "@type": "Organization",
        "name": "株式会社ソーシャルパス"
      }
    };

    // Schema.org JSON-LD for Service
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "情報セキュリティソリューション",
      "provider": {
        "@type": "Organization",
        "name": "株式会社ソーシャルパス"
      },
      "areaServed": "JP",
      "description": "情報の真正性検証技術、環境固有性NFT・ロバストネスNFTの活用、フェイクニュース対策、情報のなりすまし対策、フィッシング詐欺対策"
    };

    // Add schemas to head
    const addSchema = (schema: object, id: string) => {
      const existingScript = document.getElementById(id);
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    };

    addSchema(organizationSchema, 'schema-organization');
    addSchema(websiteSchema, 'schema-website');
    addSchema(serviceSchema, 'schema-service');

    return () => {
      document.getElementById('schema-organization')?.remove();
      document.getElementById('schema-website')?.remove();
      document.getElementById('schema-service')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <SolutionsSection />
        <TeamSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}
